import React from 'react';

// 11-col × 10-row dot-matrix heart inside a rounded-square app icon
// Each [row, col] pair is one filled square dot in the grid
const HEART_DOTS = [
  // row 0 — two bumps
  [0,1],[0,2],[0,3],          [0,7],[0,8],[0,9],
  // row 1 — bumps widen
  [1,0],[1,1],[1,2],[1,3],[1,4],  [1,6],[1,7],[1,8],[1,9],[1,10],
  // rows 2-4 — full-width body
  [2,0],[2,1],[2,2],[2,3],[2,4],[2,5],[2,6],[2,7],[2,8],[2,9],[2,10],
  [3,0],[3,1],[3,2],[3,3],[3,4],[3,5],[3,6],[3,7],[3,8],[3,9],[3,10],
  [4,0],[4,1],[4,2],[4,3],[4,4],[4,5],[4,6],[4,7],[4,8],[4,9],[4,10],
  // row 5 — start tapering
  [5,1],[5,2],[5,3],[5,4],[5,5],[5,6],[5,7],[5,8],[5,9],
  // row 6
  [6,2],[6,3],[6,4],[6,5],[6,6],[6,7],[6,8],
  // row 7
  [7,3],[7,4],[7,5],[7,6],[7,7],
  // row 8
  [8,4],[8,5],[8,6],
  // row 9 — point
  [9,5],
];

// Dot pitch = 2.5 units, dot size = 2.1 units (0.4 gap between dots)
// ViewBox is 44×44 — extra cream padding around the 27×25 heart grid
const PITCH = 2.5;
const DOT   = 2.1;
// grid width  = (11-1) * 2.5 + 2.1 = 27.1  →  OX = (44 - 27.1) / 2 = 8.45
// grid height = (10-1) * 2.5 + 2.1 = 24.6  →  OY = (44 - 24.6) / 2 = 9.70
const OX    = 8.45;
const OY    = 9.70;

const PixelHeart = () => (
  <svg
    viewBox="0 0 44 44"
    className="tone-ai-heart"
    aria-hidden="true"
    shapeRendering="crispEdges"
  >
    {/* Subtle inner shadow rim to give the icon depth */}
    <rect x="0" y="0" width="44" height="44" rx="10" ry="10" fill="#e8ddc8" />
    {/* Main cream background */}
    <rect x="0.8" y="0.8" width="42.4" height="42.4" rx="9.2" ry="9.2" fill="#f4ecda" />
    {/* Very faint warm centre wash so the heart has a lit feel */}
    <radialGradient id="hg" cx="50%" cy="48%" r="46%">
      <stop offset="0%"   stopColor="#fff8ec" stopOpacity="0.9" />
      <stop offset="100%" stopColor="#f4ecda" stopOpacity="0"   />
    </radialGradient>
    <rect x="0.8" y="0.8" width="42.4" height="42.4" rx="9.2" ry="9.2" fill="url(#hg)" />

    {/* Dot-matrix pixels */}
    {HEART_DOTS.map(([row, col]) => (
      <rect
        key={`${row}-${col}`}
        x={OX + col * PITCH}
        y={OY + row * PITCH}
        width={DOT}
        height={DOT}
        rx="0.25"
        fill="#111111"
      />
    ))}
  </svg>
);

const Project = ({ item }) => {
  const isToneAI = item.customCard === 'tone-ai';
  const Wrapper = isToneAI ? 'a' : 'div';
  const wrapperProps = isToneAI
    ? { href: 'https://github.com/Seth141/Tone_AI', target: '_blank', rel: 'noopener noreferrer' }
    : {};

  return (
    <Wrapper {...wrapperProps} className={`project-card${isToneAI ? ' project-card--tone-ai' : ''}`}>
      <div className={`project-media${isToneAI ? ' project-media--tone-ai' : ''}`}>
        {isToneAI ? (
          <PixelHeart />
        ) : (
          <img
            className='project-image'
            src={item.image}
            alt={item.name}
            loading='lazy'
            decoding='async'
          />
        )}
      </div>

      <div className='project-body'>
        <h3 className={`text-xl font-semibold capitalize mb-2 text-center${isToneAI ? ' tone-ai-title' : ' text-white'}`}>
          {item.name}
        </h3>
        <p className='text-accent text-sm clamp-3 text-center'>{item.category}</p>
      </div>
    </Wrapper>
  );
};

export default Project;
